import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
	Button,
	Form,
	FormGroup,
	InputGroup,
	Overlay,
	Popover,
} from "react-bootstrap";
import { deleteShift } from "../../actions";

class DeleteShiftOverlay extends Component {
	constructor(props) {
		super(props);
		this.state = { show: false };
	}

	deleteShift(e) {
		e.preventDefault();
		this.props.deleteShift(this.props.tvClient, this.props.shiftId);
	}

	hide2() {
		this.setState({ show: false });
	}

	render() {
		return (
				<div>
						<button
								type="button"
								className="simulateAnchor"
								ref="target"
								onClick={(e) => {
										e.preventDefault();
										this.setState({ show: true });
								}}
						>
								Delete
						</button>

						<Overlay
								show={this.state.show}
								rootClose
								target={(props) => ReactDOM.findDOMNode(this.refs.target)}
								onHide={this.hide2.bind(this)}
								placement="right"
						>
								<Popover
										id="delete-shift"
										title="DELETE"
										className="invite-patient-overlay"
								>
										<Popover.Title>DELETE</Popover.Title>
										<Popover.Content>
												<Form onSubmit={this.deleteShift.bind(this)}>
														<FormGroup controlId="confirm">
																<InputGroup>
																		<InputGroup.Prepend>
																				<p>
																						Are you sure you want to delete this
																						shift?
																				</p>
																				<Button type="submit" variant="danger">
																						Yes
																				</Button>
																		</InputGroup.Prepend>
																</InputGroup>
														</FormGroup>
												</Form>
										</Popover.Content>
								</Popover>
						</Overlay>
				</div>
		);
	}
}

const mapStateToProps = (state) => ({
		tvClient: state.login.tvClient,
});

export default connect(mapStateToProps, { deleteShift })(DeleteShiftOverlay);
